import { entity_language } from '../../config/entity_language';

export const language = {
    defaults: {
        no_results: 'Nessun risultato trovato.',
        not_found: 'Pagina non trovata.',
        rows: 'Righe',
        columns: 'Colonne',
        view: 'Visualizza',
        edit: 'Modifica',
        delete: 'Elimina',
        clear: 'Resetta',
        cancel: 'Annulla',
        image: 'Immagine',
        delete_title: 'Elimina elemento',
        delete_msg: 'Confermi di voler rimuovere questo elemento?',
        details: 'Dettagli',
        close: 'Chiudi',
        open: 'Apri',
        error: 'Errore',
        save: 'Salva',
        back: 'Torna indietro',
        search: 'Cerca',
        create: 'Crea nuovo',
        of: 'di',
        results_per_page: 'Risultati per pagina',
        no_image: 'Nessuna immagine.',
        loading: 'Caricamento',
        true: 'Sì',
        false: 'No',
        select: 'Seleziona',
        select_file: 'Seleziona file',
        add: 'Aggiungi',
        options: 'Opzioni',
        import: 'Importa',
        export: 'Esporta',
        paste_here: 'Incolla qui',
        check: 'Controlla',
        reset: 'Reset',
        preview: 'Anteprima',
        download: 'Scarica',
        open_link: 'Apri link',
        open_file: 'Apri file',
        elements: 'Elementi',
        refresh: 'Ricarica',
        clone: 'Duplica',
        selected_rows: 'Selezionati',
        delete_selection: 'Elimina selezione',
        delete_selection_confirm: 'Confermi di voler eliminare le righe selezionate?',
        confirm: 'Conferma',
        go_back_title: 'Sei sicuro di voler uscire?',
        go_back_text: 'Se esci da questa schermata senza salvare perderai tutte le modifiche apportate.',
        exit: 'Esci comunque',
        address: 'Indirizzo',
        insert_address: 'Digita un indirizzo',
        save_preferences: 'Salva preferenze',
        apply_preferences: 'Applica preferenze',
        available: 'Disponibile',
        used: 'In uso',
        available_columns: 'Colonne disponibili',
        chosen_columns: 'Colonne scelte',
        actions: 'Azioni',
        settings: 'Impostazioni'
    },
    toast: {
        loading: 'In corso...',
        insertSuccess: 'Nuovo elemento inserito con successo.',
        insertFail: 'Errore durante il salvataggio.',
        updateSuccess: 'Modifica effettuata con successo.',
        updateFail: 'Errore durante il salvataggio.',
        deleteSuccess: 'Elemento eliminato con successo.',
        deleteFail: "Errore durante l'eliminazione."
    },
    search: {
        filters: 'Filtri di ricerca',
        search_fields: 'Campi di ricerca',
        search_fields_subtitle: 'Seleziona o deseleziona i campi su cui effettuare la ricerca.',
        add_filter: 'Aggiungi filtro',
        add_filter_subtitle: 'Aggiungi filtri standard su campi specifici.',
        active_filters: 'Filtri attivi',
        active_filters_subtitle: 'Gestisci i filtri attualmente attivi sulla ricerca.',
        field_label: 'Campo',
        type_label: 'Tipo filtro',
        field_value: 'Valore',
        select_constraint_field: 'Seleziona prima il campo del filtro.',
        begin_by: 'Inizia con',
        end_by: 'Finisce con',
        equal: 'Uguale',
        contains: 'Contiene',
        different: 'Diverso',
        minor: 'Minore',
        greater: 'Maggiore',
        in: 'Includi',
        not_in: 'Escludi',
        between: 'Compreso',
        from: 'Da',
        to: 'A',
        and: 'e',
        save_filters: 'Salva filtri',
        saved_filters: 'Filtri salvati',
        success_filters_saved: 'Filtri salvati con successo.',
        fail_filters_saved: 'Non è stato possibile salvare i filtri. Controlla di averne inseriti e di aver digitato un nome.',
        reset_filters: 'Resetta filtri',
        isnull: 'Vuoto'
    },
    filterColumns: {
        sort: 'Ordina',
        sort_asc: 'Ordina A-Z',
        sort_desc: 'Ordina Z-A',
        filter: 'Filtra',
        apply_filter: 'Applica filtro',
        clear_filter: 'Rimuovi filtro',
        active_filter: 'Filtro attivo',
        filter_type: 'Tipo di filtro',
        filter_value: 'Valore del filtro',
        type_to_search: 'Digita per cercare...',
        start_typing: 'Inizia a digitare per cercare...',
        no_results_for: 'Nessun risultato per',
        searching: 'Ricerca in corso...',
        select_option: 'Seleziona opzione...',
        select_value: 'Seleziona...',
        filter_placeholder: 'Valore del filtro...',
        file_hash: 'Hash del file...'
    },
    cache: {
        cache_status: 'Stato Cache:',
        enabled: 'ABILITATA',
        disabled: 'DISABILITATA',
        cache_active: 'Il sistema di cache è attivo. I dati vengono salvati in cache per migliorare le prestazioni.',
        cache_disabled: 'Il sistema di cache è disabilitato. Tutte le richieste verranno effettuate direttamente al server.',
        enable_cache: 'Per abilitare la cache, imposta',
        in_settings: 'in settings.js',
        cache_statistics: 'Statistiche Cache',
        total_entries: 'Totale Voci',
        entities_cached: 'Entità in Cache',
        total_size: 'Dimensione Totale',
        expired_entries: 'Voci Scadute',
        last_sync_check: 'Ultimo controllo sincronizzazione:',
        clear_all_cache: 'Svuota Tutta la Cache',
        clear_expired: 'Rimuovi Scadute',
        refresh: 'Ricarica',
        cache_entries: 'Voci in Cache',
        type: 'Tipo',
        entity: 'Entità',
        cached_at: 'Salvato il',
        expires_at: 'Scade il',
        size: 'Dimensione',
        status: 'Stato',
        actions: 'Azioni',
        expired: 'Scaduto',
        valid: 'Valido',
        detail: 'Dettaglio',
        clear: 'Rimuovi',
        no_cache_entries: 'Nessuna voce in cache trovata',
        no_cache_entries_desc: 'La cache è vuota. Inizia a navigare nelle entità per vedere i dati in cache qui.',
        cache_entry_details: 'Dettagli Voce Cache',
        cached_data: 'Dati in Cache:',
        cache_key: 'Chiave Cache:',
        close: 'Chiudi',
        clear_entity_cache: 'Rimuovi Cache Entità',
        cache_cleared_success: 'Cache svuotata con successo!',
        expired_cleared_success: 'Voci scadute rimosse con successo!',
        entity_cache_cleared_success: 'Cache per l\'entità "{entity}" rimossa con successo!'
    },
    import: {
        download_template_error: 'Errore durante il download del template',
        export_failed: 'Export fallito',
        export_error: 'Errore durante l\'esportazione dei dati',
        invalid_file_type: 'Carica un file CSV o Excel',
        parse_file_error: 'Errore nell\'elaborazione del file',
        import_execute_error: 'Errore durante l\'esecuzione dell\'importazione',
        step1_title: 'Step 1: Carica File',
        step1_desc: 'Scarica il template per vedere il formato corretto, poi carica il tuo file Excel o CSV con i dati da importare.',
        download_template: 'Scarica Template',
        download_full_dataset: 'Scarica Dataset Completo',
        upload_file: 'Carica File',
        accepted_formats: 'Formati accettati: CSV, Excel (.xlsx, .xls)',
        file_loaded: 'File caricato',
        instructions: 'Istruzioni:',
        instruction1: 'Lascia la colonna ID vuota per creare nuovi record',
        instruction2: 'Fornisci un ID per aggiornare record esistenti',
        instruction3: 'Per i riferimenti esterni, usa il valore mostrato (non l\'ID)',
        instruction4: 'Le date devono essere nel formato YYYY-MM-DD',
        instruction5: 'I valori booleani possono essere: 0/1, true/false, yes/no',
        step2_title: 'Step 2: Anteprima e Validazione',
        step2_desc: 'Rivedi i dati sottostanti. Le righe con errori devono essere corrette prima dell\'importazione.',
        valid_rows: 'Righe valide',
        errors: 'Errori',
        updates: 'Aggiornamenti',
        inserts: 'Inserimenti',
        show_only_errors: 'Mostra solo righe con errori',
        row: 'Riga',
        status: 'Stato',
        errors_found: 'Errori trovati:',
        processing: 'Elaborazione...',
        import_not_available: 'Import Non Disponibile',
        sql_view_notice: 'La funzionalità di importazione non è disponibile per le viste SQL.',
        sql_view_desc: 'Questa entità ({entity}) è una vista database di sola lettura.',
        sql_view_note: 'Le viste SQL sono tabelle virtuali create da query del database e non possono essere modificate direttamente. Per aggiungere o modificare dati, utilizza le tabelle di base sottostanti.',
        error_badge: 'Errore',
        warning_badge: 'Avviso',
        update_badge: 'Aggiorna',
        insert_badge: 'Inserisci',
        yes: 'Sì',
        no: 'No',
        step3_title: 'Step 3: Importazione Completata',
        import_summary: 'Riepilogo Importazione:',
        records_inserted: 'Record inseriti',
        records_updated: 'Record aggiornati',
        back: 'Indietro',
        execute_import: 'Esegui Importazione',
        import_more: 'Importa Altri'
    },
    export: {
        export_error: 'Errore durante l\'esportazione',
        export_options: 'Opzioni di Esportazione',
        export_description: 'I dati saranno esportati con i riferimenti esterni come etichette per una facile reimportazione.',
        export_visible_columns: 'Esporta Colonne Visibili',
        export_visible_columns_description: 'Esporta solo le colonne attualmente visibili nel datagrid',
        export_all: 'Esporta Tutto',
        export_all_records: 'Esporta tutti i record con tutte le colonne',
        export_information: 'Informazioni sull\'Esportazione:',
        excel_format_info: 'Il file esportato sarà in formato Excel (.xlsx)',
        system_fields_excluded: 'I campi di sistema (data, ultimoAggiornamento, eliminato) sono esclusi',
        private_fields_excluded: 'I campi privati non vengono esportati',
        import_compatibility: 'Compatibilità Importazione:',
        mysql_view_entity: 'Questa entità è una Vista MySql',
        cannot_import_view: 'Non potrai importare questo file nel modale di importazione',
        download_from_import: 'Scarica il file corretto dal modale di importazione se disponibile',
        import_compatible_format: 'Il formato compatibile per l\'importazione include la colonna ID per gli aggiornamenti',
        preparing_export: 'Preparazione export...'
    },
    errors: {
        insert: 'Si è verificato un errore. Controlla i campi e riprova.',
        update: 'Si è verificato un errore. Controlla i campi e riprova.',
        get: 'Si è verificato un errore.'
    },
    header: {
        home: 'Homepage',
        profile: 'Profilo',
        settings: 'Impostazioni',
        notifcations: 'Notifiche',
        search: 'Ricerca',
        about: 'Informazioni',
        logout: 'Logout'
    },
    login: {
        title: 'Effettua il login',
        subtitle: '',
        username: 'Utente',
        password: 'Password',
        login: 'Accedi',
        forgot: 'Hai dimenticato la password?',
        remember: 'Ricordami',
        send_forgot_password_key: 'Invia pin',
        reset_password: 'Resetta la tua password',
        insert_password_key: 'Inserisci il pin che hai ricevuto via e-mail e la nuova password. Se non hai ricevuto il pin controlla anche nella posta indesiderata.',
        password_key: 'Pin ricevuto',
        new_password: 'Nuova password',
        confirm_new_password: 'Conferma password',
        confirm_reset: 'Conferma',
        back_to_login: 'Torna al login',
        change_password: 'Devi modificare la password',
        change_password_desc: 'Riceverai un pin via e-mail da inserire nel prossimo step per modificare la tua password.'
    },
    logout: {
        title: 'Stai per eseguire il logout.',
        subtitle: 'Sei sicuro di voler effettuare il logout?',
        confirm: 'Confermo'
    },
    settings: {
        user_settings: 'Impostazioni utente',
        general: 'Generali',
        avatar: 'Immagine profilo',
        security: 'Sicurezza',
        name: 'Nome',
        surname: 'Cognome',
        sex: 'Sesso',
        general_success: 'Profilo modificato con successo.',
        general_save: 'Modifica profilo',
        female: 'Donna',
        male: 'Uomo',
        password: 'Password attuale',
        new_password: 'Nuova password',
        confirm_password: 'Conferma nuova password',
        security_save: 'Modifica password',
        security_success: 'Password modificata con successo.',
        passwords_match_error: 'Le password non coincidono.',
        avatar_save: 'Aggiorna avatar',
        avatar_now: 'Immagine profilo attuale',
        avatar_success: 'Immagine profilo modificata con successo.'
    },
    version: {
        update_available: 'Aggiornamento Disponibile',
        update_message: 'È disponibile una nuova versione dell\'applicazione. Per utilizzare le nuove funzionalità è necessario ricaricare la pagina.',
        new_version: 'Nuova versione',
        reload_now: 'Ricarica Ora'
    },
    ...entity_language
};